export const getInitials = (fullName) => {
  if (!fullName) {
    return null;
  }
  if (typeof fullName !== "string") {
    return fullName;
  }
  let initials = "";
  const names = fullName.split(" ").filter((name) => name.length !== 0);
  names.forEach((name) => {
    initials += name[0];
  });

  return initials?.length > 2
    ? initials[0] + initials[initials.length - 1]
    : initials;
};
